/**
 * Created by Gaplo917 on 6/9/2017.
 */
import * as PIXI from 'pixi.js'
import Image from "./Image";
import R from "../config/R";
import * as Events from "../Events";
import TWEEN from "@tweenjs/tween.js"

const MAX_LENGTH = 778

export class TimeBar extends PIXI.Container {
  static get COUNT_DOWN_END() {
    return "TIMEBAR_COUNT_DOWN_END"
  }

  constructor(x, y, resources){
    super()
    this.x = x
    this.y = y

    const clock = new Image(-7,20, resources[R.images.clock.name].texture)
    const timebarBg = new Image(228,26, resources[R.images.timeBar.name].texture)
    clock.scale.x = 0.5
    clock.scale.y = 0.5

    timebarBg.scale.x = 0.5
    timebarBg.scale.y = 0.5

    const runningBar = new PIXI.Container()
    runningBar.x = 35
    runningBar.y = 9

    const mask = new PIXI.Graphics();
    mask.beginFill(0xFFFF00);
    mask.drawRoundedRect(135, 64, MAX_LENGTH / 2, 71 / 2, 35.5 / 2);
    runningBar.mask = mask

    this.addChild(timebarBg)
    this.addChild(runningBar)
    this.addChild(clock)

    this.runningBar = runningBar

    this.setBar(1)
  }

  get value(){
    return this._timeLeft
  }

  setBar(ratio){
    const { runningBar } = this
    if(this.currentBar) {
      runningBar.removeChild(this.currentBar)
    }

    const graphics = new PIXI.Graphics();
    graphics.beginFill(0xff675b, 1);
    graphics.drawRect(0, 0, MAX_LENGTH * ratio / 2, 71 / 2);
    graphics.endFill();

    runningBar.addChild(graphics)
    this.currentBar = graphics
  }

  // auto end when the count down finish
  start(ticker, seconds){
    this._frame = 0
    const fps = ticker.FPS

    const update = () => {
      if(this._frame >= fps * seconds) {
        this.setBar(0)
        this._timeLeft = 0
        ticker.remove(update)
        Events.hub.publishEvent(Events.TIMES_UP)
      }
      else {
        const timeElapsed = this._frame / fps
        const timeLeft = seconds - timeElapsed
        this.setBar(timeLeft / seconds)

        this._timeLeft = timeLeft
      }

      this._frame += 1
    }

    ticker.add(update)

    this.update = update
    this.ticker = ticker
    this.seconds = seconds
  }

  deductTime(second) {
    this._frame += second * this.ticker.FPS

    const textStyle = {
      ...new PIXI.TextStyle(R.textStyles.timer(60)),
      fill: '#FFFFFF',
    }

    const deduceText = new PIXI.Text("-10", textStyle)

    deduceText.x = 450 * (this._timeLeft / this.seconds)
    deduceText.y = 0
    this.addChild(deduceText)


    new TWEEN.Tween(deduceText)
      .to({y: -300, alpha: 0}, 5000)
      .easing(TWEEN.Easing.Quadratic.Out)
      .onComplete(() => {
        this.removeChild(deduceText)
      })
      .start()
  }

  stop(){
    if(this.ticker && this.update) {
      this.ticker.remove(this.update)
    }
  }

  restart(){
    if(!this.ticker || !this.seconds){
      throw Error("you should run CircleTimer.start(ticker, seconds) first")
    }
    this.start(this.ticker, this.seconds)
  }

}



// WEBPACK FOOTER //
// ./src/game/objects/TimeBar.js